import { useEffect } from 'react';

import { useAppContext } from '../../../../AppModulesWrapper';
import { useTelemetry } from '../../../../common/hooks';

export const useScriptsLoadingErrorsLogger = () => {
  const { logger } = useAppContext();
  const { increment } = useTelemetry();

  useEffect(() => {
    if (window && window.STYLES_LOADING_ERROR_LINKS?.length) {
      logger.error('Scripts loading error', {
        scripts: window.STYLES_LOADING_ERROR_LINKS,
        message: 'Не были загружен ресурсы из CDN',
      });

      increment('scriptsLoadingErrors');

      window.STYLES_LOADING_ERROR_LINKS = [];
    }
  }, [logger, increment]);
};
